export const getUrlHash = () => window.location.hash.substr(1)
